import { useEffect } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import DynamicTable from "src/components/table";
import {
  columntype,
  dataLocalStorage,
  getLocalStorage,
  inputType,
  isValidArray,
} from "src/helper/publicFunction";
import DynamicModal from "src/components/modal/DynamicModal";
import * as Yup from "yup";
import { CommonAlert } from "src/components/alert/CommonAlert";
import {
  ManageSubServices,
  DeleteSubService,
  GetSubServices,
  EditSubServices,
} from "./actions";
import { GetMainServices } from "../main_services/actions";

const SubServices = () => {
  const dispatch = useDispatch();
  const Commonalert = CommonAlert(); // Create an alert object using the function
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState([]);
  const [loadingData, setLoadingData] = useState(true);
  const [loadingEditdatatype, setloadingEditdatatype] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [array, setarray] = useState([]);
  const [values, setvalues] = useState({});
  const [editMode, setEditMode] = useState(false);
  const [data, setData] = useState([]);
  const [mediaTypes, setMediaTypes] = useState([]);
  const [TotalData, setTotalData] = useState(0);
  let dataPrivileges = getLocalStorage(dataLocalStorage.privileges);

  const Schema = Yup.object().shape({
    name: Yup.string().trim().required("required"),
    description_short: Yup.string().trim().required("required"),
    description_long: Yup.string().trim().required("required"),
    image: Yup.string().trim().required("required"),
    // demo_video: Yup.string().trim().required("required"), not required
    main_service_id: Yup.string().trim().required("required"),
    is_applicable_form: Yup.string().trim().required("required"),
  });

  const GetData = ({ tableName = null, type = null }) => {
    setLoadingData(true);
    setData([]);
    dispatch(
      GetSubServices({
        rowsPerPage: rowsPerPage,
        page: page,
        callback: (data) => {
          if (isValidArray(data?.data)) {
            setData(data?.data);
            setTotalData(data?.count);
          } else {
            setData([]);
            setTotalData(0);
          }
          setLoadingData(false);
        },
      })
    );
    dispatch(
      GetMainServices({
        page: 0,
        rowsPerPage: 500,
        callback: (data) => {
          if (isValidArray(data?.data)) {
            setMediaTypes(data?.data);
            if (array.length == 0) {
              setarray([
                {
                  failed: "id",
                  type: inputType.text,
                  title: "id",
                  placeholder: "",
                  fullwidth: true,
                  customdesign: { display: "none" },
                },
                {
                  failed: "name",
                  type: inputType.text,
                  title: "Name",
                  placeholder: "",
                  fullwidth: true,
                  customdesign: { width: "100%" },
                },
                {
                  failed: "description_short",
                  type: inputType.text,
                  title: "Description Short",
                  placeholder: "",
                  fullwidth: true,
                  customdesign: { width: "100%" },
                },
                {
                  failed: "description_long",
                  type: inputType.editor,
                  title: "Description Long",
                  placeholder: "",
                  fullwidth: true,
                  customdesign: { width: "100%" },
                },
                {
                  failed: "image",
                  type: inputType.image,
                  title: "Image",
                  placeholder: "",
                  fullwidth: true,
                  customdesign: { width: "100%" },
                  fileTypes: ["JPG", "PNG", "JPEG", "WEBP"],
                  multiple: false,
                  label: "Click to select image",
                  fileOrFiles: "File", //Array or File or null
                },
                {
                  failed: "demo_video",
                  type: inputType.image,
                  title: "Demo Video",
                  placeholder: "",
                  fullwidth: true,
                  customdesign: { width: "100%" },
                  fileTypes: ["MP3", "WAV", "MP4", "AAC", "FLAC", "OGG"],
                  multiple: false,
                  label: "Click to select video",
                  fileOrFiles: "File", //Array or File or null
                },
                {
                  failed: "main_service_id",
                  type: inputType.dropdown,
                  title: "Service Type",
                  placeholder: "",
                  fullwidth: true,
                  customdesign: { width: "100%" },
                  datadropdown: data?.data,
                  faileddropdown: {
                    name: "name",
                    value: "id",
                  },
                },
                {
                  failed: "is_applicable_form",
                  type: inputType.dropdown,
                  title: "Applicable Form",
                  placeholder: "",
                  fullwidth: true,
                  customdesign: { width: "100%" },
                  datadropdown: [
                    { name: "Yes", value: 1 },
                    { name: "No", value: 0 },
                  ],
                  faileddropdown: {
                    name: "name",
                    value: "value",
                  },
                },
              ]);
            }
          } else {
            setMediaTypes([]);
          }
        },
      })
    );
  };

  useEffect(() => {
    GetData({ tableName: null, type: null });
  }, [page, rowsPerPage, search]);

  const columns = [
    { type: columntype.text, name: "id" },
    { type: columntype.text, name: "name" },
    { type: columntype.image, name: "image" },
    { type: columntype.text, name: "description_short", limitText: true },
    { type: columntype.text, name: "description_long", limitText: true },
    { type: columntype.vid, name: "demo_video" },
    { type: columntype.text, name: "main_service" },
    { type: columntype.switch, name: "is_applicable_form" },
    { type: columntype.switch, name: "is_active" },
  ];

  const headCells = [
    {
      id: "id",
      numeric: false,
      disablePadding: false,
      label: "id",
      withSort: false,
    },
    {
      id: "name",
      numeric: false,
      disablePadding: false,
      label: "Name",
      withSort: false,
    },
    {
      id: "image",
      numeric: false,
      disablePadding: false,
      label: "Image",
      withSort: false,
    },
    {
      id: "description_short",
      numeric: false,
      disablePadding: false,
      label: "Description (Short)",
      withSort: false,
    },
    {
      id: "description_long",
      numeric: false,
      disablePadding: false,
      label: "Description (Long)",
      withSort: false,
    },
    {
      id: "demo_video",
      numeric: false,
      disablePadding: false,
      label: "Demo Video",
      withSort: true,
    },

    {
      id: "main_service",
      numeric: false,
      disablePadding: false,
      label: "Main Service",
      withSort: true,
    },
    {
      id: "is_applicable_form",
      numeric: false,
      disablePadding: false,
      label: "Applicable Form",
      withSort: false,
    },
    {
      id: "is_active",
      numeric: false,
      disablePadding: false,
      label: "Is active",
      withSort: true,
    },
    (dataPrivileges["28"]?.access_edit == 1 ||
      dataPrivileges["28"]?.access_delete == 1) && {
      id: "action",
      numeric: false,
      disablePadding: false,
      label: "Action",
      withSort: false,
    },
  ];

  const List = [
    dataPrivileges["28"]?.access_delete == 1 && {
      name: "Delete",
      function: async (row) => {
        if (row) {
          Commonalert.show({
            title: `Are you sure to delete ${row?.title ?? ""}?`,
            message: "You won't be able to revert this!",
            type: "delete",
            actions: [
              {
                name: "Yes",
                callback: () =>
                  dispatch(
                    DeleteSubService({
                      callback: () => {
                        GetData({ tableName: null, type: null });
                      },
                      mediaListId: [row.id],
                    })
                  ),
                type: "delete",
              },
              {
                name: "No",
                callback: () => {},
                type: "cancel",
              },
            ],
          });
        }
      },
    },
    dataPrivileges["28"]?.access_edit == 1 && {
      name: "Edit",
      function: async (data) => {
        setEditMode(true);
        setvalues(data);
        setShowModal(true);
      },
    },
  ];

  const updateDataApi = ({ row, failedName, newData }) => {
    setloadingEditdatatype(`${row?.id}-${failedName}`);
    dispatch(
      EditSubServices({
        id: row?.id,
        dataFailed: newData,
        nameFailed: failedName,
        callback: () => {
          updateDataLocal({ id: row.id, failedName, newData });
        },
      })
    );
  };

  const updateDataLocal = ({ id, failedName, newData }) => {
    setData((prevData) => {
      return prevData.map((item) => {
        if (item.id === id) {
          return {
            ...item,
            [failedName]: newData,
          };
        }
        return item;
      });
    });
    setloadingEditdatatype("");
  };

  return (
    <>
      <DynamicTable
        withNavigateToFormAndLinkIs="/sub-services-media-gallery"
        handleSearch={(event) => setSearch(event.target.value)} // call api
        onRequestSort={(tableName, type) => {
          if (tableName && type) {
            GetData({ tableName, type });
          }
        }} // call api
        onPressDelete={(mediaListId) => {
          Commonalert.show({
            title: "Are you sure?",
            message: "You won't be able to revert this!",
            type: "delete",
            actions: [
              {
                name: "Yes",
                callback: () =>
                  dispatch(
                    DeleteSubService({
                      callback: () => {
                        GetData({ tableName: null, type: null });
                      },
                      mediaListId: mediaListId,
                    })
                  ),

                type: "delete",
              },
              {
                name: "No",
                callback: () => {},
                type: "cancel",
              },
            ],
          });
        }} // call api
        onPressItem={(row) => {}} // when press item
        onPressAnyAction={(row, failedName, newData) => {
          updateDataApi({ row, failedName, newData });
        }} // when press checkbox or switch
        onPressAdd={() => {
          setvalues({});
          setEditMode(false);
          setShowModal(true);
        }} // when press add new button show modal to add new item
        items={data} // all data
        columns={columns} // type of data
        headCells={headCells} // columns name
        page={page} // number of page from api
        setPage={setPage} // set number of page from api
        selected={selected} // selected items
        setSelected={setSelected} // set selected items
        search={search} // search failed
        rowsPerPage={rowsPerPage} // number show Data
        setRowsPerPage={setRowsPerPage} // set number show data
        Listdropdown={List} // list action with function
        withOption={true} // for remove action column
        loadingData={loadingData} // when load data from api
        rowsPerPageOptions={[5, 10, 25, 50]} // set option number of show data
        totalItem={TotalData} // total data without pagination
        loadingEditdatatype={loadingEditdatatype} // first failed (id) and second (failed Name) like ={"1-is_active"}
        withAddButton={dataPrivileges["28"]?.access_write === 1}
        withDeleteItem={dataPrivileges["28"]?.access_delete === 1}
        withEditItem={dataPrivileges["28"]?.access_edit === 1}
        withPagination={true}
        withSearch={false}
      />
      {showModal ? (
        <DynamicModal
          show={showModal}
          setShow={setShowModal}
          faileds={array}
          values={values}
          title={"Sub Services"}
          editMode={editMode}
          description={editMode ? "Edit" : "Add new sub-service"}
          buttonTitle={editMode ? "Edit" : "Add"}
          onSubmit={(valuess) => {
            dispatch(
              ManageSubServices({
                editMode: editMode,
                values: valuess,
                callback: (res) => {
                  if (res) {
                    setShowModal(false);
                    GetData({ tableName: null, type: null });
                  }
                },
              })
            );
          }}
          Schema={Schema}
        />
      ) : null}
    </>
  );
};

export default SubServices;
